export var getComponentId = function () {
    var query = new URLSearchParams(window.location.search);
    return query.get('origCompId');
};
//# sourceMappingURL=query.js.map